"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSite = exports.getSite = exports.getSiteDeployments = exports.getSites = void 0;
const _ = require("lodash");
const getSites = async (supabase) => {
    const { data, error } = await supabase
        .from("sites")
        .select(`*, logs:site_deployments(*)`);
    if (!error) {
        return data;
    }
    return error;
};
exports.getSites = getSites;
const getSiteDeployments = async (supabase, site_id) => {
    const { data, error } = await supabase
        .from("site_deployments")
        .select(`*`)
        .eq("site_id", site_id);
    if (!error) {
        return data;
    }
    return error;
};
exports.getSiteDeployments = getSiteDeployments;
const getSite = async (supabase, id) => {
    const { data, error } = await supabase
        .from("sites")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getSite = getSite;
const updateSite = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data, error } = await supabase
        .from("sites")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateSite = updateSite;
